export const ConsultationsAPI = {
  consultations: {
    list: '/consultations',
  },
}
